import React from 'react';
import { Globe } from 'lucide-react';
import { useSettings } from '../../contexts/SettingsContext';
import { getAssetUrl } from '../../utils/assetUrl';

type SiteLogoSize = 'sm' | 'md' | 'lg';

const sizeClasses: Record<SiteLogoSize, { box: string; icon: string; text: string }> = {
  sm: { box: 'w-8 h-8', icon: 'w-5 h-5', text: 'text-xl' },
  md: { box: 'w-10 h-10', icon: 'w-6 h-6', text: 'text-2xl' },
  lg: { box: 'w-12 h-12', icon: 'w-8 h-8', text: 'text-3xl' }
};

interface SiteLogoProps {
  size?: SiteLogoSize;
  showName?: boolean;
  nameClassName?: string;
  className?: string;
}

const SiteLogo: React.FC<SiteLogoProps> = ({
  size = 'md',
  showName = true,
  nameClassName = 'font-bold text-gray-900',
  className = ''
}) => {
  const { settings } = useSettings();
  const siteName = settings?.site?.name || 'NEIA';
  const logoUrl = settings?.site?.logo?.trim();
  const resolvedLogo = logoUrl ? getAssetUrl(logoUrl) : '';
  const s = sizeClasses[size];

  return (
    <span className={`inline-flex items-center space-x-2 ${className}`}>
      {resolvedLogo ? (
        <img
          src={resolvedLogo}
          alt={siteName}
          className={`${s.box} object-contain rounded-lg`}
        />
      ) : (
        <span
          className={`${s.box} bg-gradient-to-br from-primary-600 to-secondary-600 rounded-lg flex items-center justify-center shrink-0`}
        >
          <Globe className={`${s.icon} text-white`} />
        </span>
      )}
      {showName && (
        <span className={`${s.text} ${nameClassName}`}>{siteName}</span>
      )}
    </span>
  );
};

export default SiteLogo;
